/* eslint-disable react/prefer-stateless-function */
// TODO make System404 a pure function
import React from 'react'
import { Helmet } from 'react-helmet'
import { Result } from 'antd'

import 'antd/lib/result/style'

export class System404 extends React.Component {
  render() {
    return (
      <Result status="404" title="404" subTitle="Sorry, the page you visited does not exist.">
        <Helmet title="Page 404" />
      </Result>
    )
  }
}
// export default System404;

export default {
  name: '404',
  routeProps: {
    path: '/404',
    component: System404,
  },
}
